import { createRouter, createWebHistory } from 'vue-router';
import { ElMessage } from 'element-plus';

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: '登录',
      requireAuth: false,
    },
  },
  {
    path: '/',
    name: 'Main',
    component: () => import('../layouts/MainLayout.vue'),
    meta: {
      title: '首页',
      requireAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
          title: '首页',
        },
      },
      // 后台账号管理
      {
        path: 'admin-users/list',
        name: 'AdminUserList',
        component: () => import('../views/users/UserList.vue'),
        meta: {
          title: '后台账号列表',
        },
      },
      // 用户管理
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('../views/user-management/UserManagement.vue'),
        meta: {
          title: '用户管理',
        },
      },
      // 积分审核管理
      {
        path: 'points/audit',
        name: 'PointsAudit',
        component: () => import('../views/points/PointsAudit.vue'),
        meta: {
          title: '积分审核',
        },
      },
      // 二奢回收管理
      {
        path: 'recycle-management',
        name: 'LuxuryRecycle',
        component: () => import('../views/recycle-management/LuxuryRecycle.vue'),
        meta: {
          title: '二奢回收管理',
        },
      },
      // 兑换商品管理
      {
        path: 'exchange-products',
        name: 'ExchangeProducts',
        component: () => import('../views/exchange-products/ExchangeProducts.vue'),
        meta: {
          title: '兑换商品管理',
        },
      },
      // 实物订单管理
      {
        path: 'physical-orders',
        name: 'PhysicalOrders',
        component: () => import('../views/orders/PhysicalOrders.vue'),
        meta: {
          title: '实物订单管理',
        },
      },
      // 权益订单管理
      {
        path: 'benefit-orders',
        name: 'BenefitOrders',
        component: () => import('../views/orders/BenefitOrders.vue'),
        meta: {
          title: '权益订单管理',
        },
      },
      // 角色管理
      {
        path: 'roles/list',
        name: 'RoleList',
        component: () => import('../views/roles/RoleList.vue'),
        meta: {
          title: '角色列表',
        },
      },

      // 消费管理
      {
        path: 'consumptions/list',
        name: 'ConsumptionList',
        component: () => import('../views/consumptions/ConsumptionList.vue'),
        meta: {
          title: '消费记录列表',
        },
      },
      {
        path: 'consumptions/create',
        name: 'ConsumptionCreate',
        component: () => import('../views/consumptions/ConsumptionCreate.vue'),
        meta: {
          title: '添加消费记录',
        },
      },
      {
        path: 'consumptions/detail/:id',
        name: 'ConsumptionDetail',
        component: () => import('../views/consumptions/ConsumptionDetail.vue'),
        meta: {
          title: '消费记录详情',
        },
      },
      // 房间管理
      {
        path: 'rooms/list',
        name: 'RoomList',
        component: () => import('../views/rooms/RoomList.vue'),
        meta: {
          title: '房间列表',
        },
      },
      {
        path: 'rooms/create',
        name: 'RoomCreate',
        component: () => import('../views/rooms/RoomCreate.vue'),
        meta: {
          title: '添加房间',
        },
      },
      {
        path: 'rooms/edit/:id',
        name: 'RoomEdit',
        component: () => import('../views/rooms/RoomEdit.vue'),
        meta: {
          title: '编辑房间',
        },
      },
      {
        path: 'rooms/detail/:id',
        name: 'RoomDetail',
        component: () => import('../views/rooms/RoomDetail.vue'),
        meta: {
          title: '房间详情',
        },
      },
      // 预订管理
      {
        path: 'bookings/list',
        name: 'BookingList',
        component: () => import('../views/bookings/BookingList.vue'),
        meta: {
          title: '预订列表',
        },
      },
      {
        path: 'bookings/create',
        name: 'BookingCreate',
        component: () => import('../views/bookings/BookingCreate.vue'),
        meta: {
          title: '添加预订',
        },
      },
      {
        path: 'bookings/edit/:id',
        name: 'BookingEdit',
        component: () => import('../views/bookings/BookingEdit.vue'),
        meta: {
          title: '编辑预订',
        },
      },
      {
        path: 'bookings/detail/:id',
        name: 'BookingDetail',
        component: () => import('../views/bookings/BookingDetail.vue'),
        meta: {
          title: '预订详情',
        },
      },
      // 评价与反馈管理
      {
        path: 'feedbacks/list',
        name: 'FeedbackList',
        component: () => import('../views/feedbacks/FeedbackList.vue'),
        meta: {
          title: '评价与反馈列表',
        },
      },
      {
        path: 'feedbacks/detail/:id',
        name: 'FeedbackDetail',
        component: () => import('../views/feedbacks/FeedbackDetail.vue'),
        meta: {
          title: '评价与反馈详情',
        },
      },
      // 图文管理
      {
        path: '/contents/banners',
        name: 'BannerList',
        component: () => import('../views/contents/BannerList.vue'),
        meta: {
          title: '轮播图管理',
        },
      },
      {
        path: '/contents/banner-create',
        name: 'BannerCreate',
        component: () => import('../views/contents/BannerCreate.vue'),
        meta: {
          title: '添加轮播图',
        },
      },
      {
        path: '/contents/banner-edit/:id',
        name: 'BannerEdit',
        component: () => import('../views/contents/BannerEdit.vue'),
        meta: {
          title: '编辑轮播图',
        },
      },
      {
        path: '/contents/customer-service-contacts',
        name: 'CustomerServiceContactList',
        component: () => import('../views/contents/CustomerServiceContactList.vue'),
        meta: {
          title: '客服联系方式管理',
        },
      },

      // 活动管理
      {
        path: 'activities',
        name: 'ActivityList',
        component: () => import('../views/activities/ActivityList.vue'),
        meta: {
          title: '活动列表',
        },
      },
      {
        path: 'activities/create',
        name: 'ActivityCreate',
        component: () => import('../views/activities/ActivityCreate.vue'),
        meta: {
          title: '创建活动',
        },
      },
      {
        path: 'activities/:id',
        name: 'ActivityDetail',
        component: () => import('../views/activities/ActivityDetail.vue'),
        meta: {
          title: '活动详情',
        },
      },
      {
        path: 'activities/:id/edit',
        name: 'ActivityEdit',
        component: () => import('../views/activities/ActivityEdit.vue'),
        meta: {
          title: '编辑活动',
        },
      },
      {
        path: 'activities/:id/registrations',
        name: 'ActivityRegistrationList',
        component: () => import('../views/activities/ActivityRegistrationList.vue'),
        meta: {
          title: '活动报名列表',
        },
      },
      // 旅拍管理
      {
        path: 'tourism-photography/packages',
        name: 'PhotoPackageList',
        component: () => import('../views/tourism-photography/PhotoPackageList.vue'),
        meta: {
          title: '旅拍套餐列表',
        },
      },
      {
        path: 'tourism-photography/consultations',
        name: 'PhotoConsultationList',
        component: () => import('../views/tourism-photography/PhotoConsultationList.vue'),
        meta: {
          title: '旅拍咨询列表',
        },
      },
      // 会员设置
      {
        path: 'member/settings',
        name: 'MemberSettings',
        component: () => import('../views/member/MemberSettings.vue'),
        meta: {
          title: '会员设置',
        },
      },
      // 店务账号管理
      {
        path: 'member/shop-accounts',
        name: 'ShopAccounts',
        component: () => import('../views/member/ShopAccounts.vue'),
        meta: {
          title: '店务账号管理',
        },
      },
      // 设施模块
      {
        path: 'facilities',
        redirect: '/rooms/list',
      },
      // 商户与设施列表
      {
        path: 'merchants/facilities',
        name: 'MerchantFacilitiesList',
        component: () => import('../views/stores/StoreList.vue'),
        meta: {
          title: '商户与设施列表',
          requireAuth: true,
        },
      },
      {
        path: 'member/benefits',
        name: 'MemberBenefits',
        component: () => import('../views/member/MemberBenefits.vue'),
        meta: {
          title: '会员权益管理',
        },
      },
      {
        path: 'member/list',
        name: 'MemberList',
        component: () => import('../views/member/MergedUserMemberList.vue'),
        meta: {
          title: '会员用户列表',
        },
      },
      {
        path: 'points/history',
        name: 'PointsDetail',
        component: () => import('../views/member/PointsDetail.vue'),
        meta: {
          title: '积分明细',
        },
      },
      // 商品管理
      {
        path: 'product/category',
        name: 'ProductCategory',
        component: () => import('../views/products/ProductCategory.vue'),
        meta: {
          title: '商品分类',
        },
      },
      {
        path: 'product/list',
        name: 'ProductList',
        component: () => import('../views/products/ProductList.vue'),
        meta: {
          title: '商品列表',
        },
      },
      {
        path: 'product/home-page',
        name: 'ProductHomePage',
        component: () => import('../views/products/ProductHomePage.vue'),
        meta: {
          title: '首页商品',
        },
      },
      // 订单管理
      {
        path: 'orders/list',
        name: 'OrderList',
        component: () => import('../views/orders/OrderList.vue'),
        meta: {
          title: '订单列表',
        },
      },
      {
        path: 'orders/refund',
        name: 'RefundRecords',
        component: () => import('../views/orders/RefundRecords.vue'),
        meta: {
          title: '退款记录',
        },
      },
      // 预约商品管理
      {
        path: 'appointment-products',
        name: 'AppointmentProducts',
        component: () => import('../views/appointment-products/AppointmentProducts.vue'),
        meta: {
          title: '预约商品管理',
        },
      },
      // 预约单列表
      {
        path: 'appointment-records',
        name: 'AppointmentRecords',
        component: () => import('../views/appointment-products/AppointmentRecords.vue'),
        meta: {
          title: '预约单列表',
        },
      },

      // 手工教室
      {
        path: 'art-crafts',
        name: 'ArtCraftList',
        component: () => import('../views/art-crafts/ArtCraftList.vue'),
        meta: {
          title: '手工教室列表',
        },
      },
      // 手工教室列表（兼容路径）
      {
        path: 'art-crafts/list',
        name: 'ArtCraftList2',
        component: () => import('../views/art-crafts/ArtCraftList.vue'),
        meta: {
          title: '手工教室列表',
        },
      },
      // 房间管理
      {
        path: 'rooms/management',
        name: 'RoomManagement',
        component: () => import('../views/rooms/RoomList.vue'),
        meta: {
          title: '房间管理',
        },
      },
      // 路客云消费管理
      {
        path: 'lukeyun-orders',
        name: 'LukeyunOrderList',
        component: () => import('../views/lukeyun/OrderList.vue'),
        meta: {
          title: '路客云订单管理',
        },
      },
      // 消费会员卡管理
      {
        path: 'member-cards',
        name: 'MemberCardList',
        component: () => import('../views/member-cards/CardList.vue'),
        meta: {
          title: '会员卡管理',
        },
      },
      // 门店信息管理
      {
        path: 'stores',
        name: 'StoreList',
        component: () => import('../views/stores/StoreList.vue'),
        meta: {
          title: '门店列表',
        },
      },
      // 设施分类管理
      {
        path: 'store-categories',
        name: 'StoreCategoryList',
        component: () => import('../views/stores/StoreCategoryList.vue'),
        meta: {
          title: '设施分类管理',
        },
      },
      // 路线定制管理
      {
        path: 'routes',
        name: 'RouteCustomization',
        component: () => import('../views/routes/RouteCustomization.vue'),
        meta: {
          title: '线路定制',
        },
      },
      // 旅游攻略管理
      {
        path: 'travel-guides',
        name: 'TravelGuideList',
        component: () => import('../views/travel-guides/TravelGuideList.vue'),
        meta: {
          title: '旅游攻略列表',
        },
      },
      // 商家信息管理
      {
        path: 'merchants',
        name: 'MerchantList',
        component: () => import('../views/merchants/MerchantList.vue'),
        meta: {
          title: '商家列表',
        },
      },
      // 卡券管理
      {
        path: 'coupons',
        name: 'CouponList',
        component: () => import('../views/coupons/CouponList.vue'),
        meta: {
          title: '卡券列表',
        },
      },
      // 用户卡券管理
      {
        path: 'user-coupons',
        name: 'UserCouponList',
        component: () => import('../views/coupons/UserCouponList.vue'),
        meta: {
          title: '领取列表',
        },
      },
      // 手动发券
      {
        path: 'user-coupons/manual-issue',
        name: 'ManualIssueCoupon',
        component: () => import('../views/coupons/ManualIssueCoupon.vue'),
        meta: {
          title: '手动发券',
        },
      },
      // 核销记录
      {
        path: 'user-coupons/redeem-logs',
        name: 'RedeemLogs',
        component: () => import('../views/coupons/RedeemLogs.vue'),
        meta: {
          title: '核销记录',
        },
      },
      // 积分设置
      {
        path: 'points/settings',
        name: 'PointsSettings',
        component: () => import('../views/points/PointsSettings.vue'),
        meta: {
          title: '积分设置',
        },
      },
      // 支付方式管理
      {
        path: 'points/payment-methods',
        name: 'PaymentMethodList',
        component: () => import('../views/points/PaymentMethodList.vue'),
        meta: {
          title: '支付方式管理',
        },
      },
      // 消费渠道管理
      {
        path: 'points/consumption-channels',
        name: 'ConsumptionChannelList',
        component: () => import('../views/points/ConsumptionChannelList.vue'),
        meta: {
          title: '消费渠道管理',
        },
      },
      // 签到
      {
        path: 'points/checkin',
        name: 'Checkin',
        component: () => import('../views/points/Checkin.vue'),
        meta: {
          title: '每日签到',
        },
      },
      // 系统-运营相关
      {
        path: 'operation-logs',
        name: 'OperationLogs',
        component: () => import('../views/system/OperationLogs.vue'),
        meta: {
          title: '操作记录',
        },
      },
      // 个人资料
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/system/Profile.vue'),
        meta: {
          title: '个人资料',
        },
      },
      // 导出记录
      {
        path: 'exports',
        name: 'ExportRecords',
        component: () => import('../views/exports/ExportRecordList.vue'),
        meta: {
          title: '导出记录',
        },
      },
      // 页面内容管理
      {
        path: 'page-contents/navigation-guide',
        name: 'NavigationGuide',
        component: () => import('../views/page-contents/NavigationGuide.vue'),
        meta: {
          title: '导航指引',
        },
      },
      {
        path: 'page-contents/member-rules',
        name: 'MemberRules',
        component: () => import('../views/page-contents/MemberRules.vue'),
        meta: {
          title: '会员规则说明',
        },
      },
      {
        path: 'page-contents/usage-tutorial',
        name: 'UsageTutorial',
        component: () => import('../views/page-contents/UsageTutorial.vue'),
        meta: {
          title: '使用教程',
        },
      },
      {
                path: 'page-contents/user-agreement',
                name: 'UserAgreement',
                component: () => import('../views/page-contents/UserAgreement.vue'),
                meta: {
                  title: '用户协议',
                },
              },
              {
                path: 'page-contents/order-number-guide',
                name: 'OrderNumberGuide',
                component: () => import('../views/page-contents/OrderNumberGuide.vue'),
                meta: {
                  title: '单号上传查找攻略',
                },
              },
              {
                path: 'page-contents/transaction-proof-guide',
                name: 'TransactionProofGuide',
                component: () => import('../views/page-contents/TransactionProofGuide.vue'),
                meta: {
                  title: '交易凭证参考示例',
                },
              },
      // 门店设置
      {
        path: 'store-settings',
        name: 'StoreSettings',
        component: () => import('../views/store/StoreSettings.vue'),
        meta: {
          title: '门店设置',
        },
      },
      // 到店回收时段设置
      {
        path: 'recycle-time-slots',
        name: 'RecycleTimeSlots',
        component: () => import('../views/store/RecycleTimeSlots.vue'),
        meta: {
          title: '到店回收时段设置',
        },
      },
      // 支持的物流公司
      {
        path: 'express-companies',
        name: 'ExpressCompanies',
        component: () => import('../views/express-companies/ExpressCompanies.vue'),
        meta: {
          title: '支持的物流公司',
        },
      },
      // 收发货配置
      {
        path: 'express-settings',
        name: 'ExpressSettings',
        component: () => import('../views/store/ExpressSettings.vue'),
        meta: {
          title: '收发货配置',
        },
      },
      // 打单员管理
      {
        path: 'printer-operators',
        name: 'PrinterOperators',
        component: () => import('../views/printer-operators/PrinterOperators.vue'),
        meta: {
          title: '打单员管理',
        },
      },
      // 统计模块
      {
        path: 'statistics/mall-order-trend',
        name: 'MallOrderTrend',
        component: () => import('../views/statistics/MallOrderTrend.vue'),
        meta: {
          title: '商城订单趋势',
        },
      },
      {
        path: 'statistics/mall-refund-trend',
        name: 'MallRefundTrend',
        component: () => import('../views/statistics/MallRefundTrend.vue'),
        meta: {
          title: '商城退款趋势',
        },
      },
      {
        path: 'statistics/consumption-trend',
        name: 'ConsumptionTrend',
        component: () => import('../views/statistics/MallConsumptionTrend.vue'),
        meta: {
          title: '商城消费趋势',
        },
      },
      {
        path: 'statistics/member-analysis',
        name: 'MemberAnalysis',
        component: () => import('../views/statistics/MemberAnalysis.vue'),
        meta: {
          title: '会员分析',
        },
      },

    ],
  },
  // 未开发页面（替代404页面，提供更好的用户体验）
  {
    path: '/:pathMatch(.*)*',
    name: 'UnDeveloped',
    component: () => import('../views/UnDeveloped.vue'),
    meta: {
      title: '功能开发中',
      requireAuth: true,
    },
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 路由切换时滚动到顶部
    return { top: 0 };
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = `${to.meta.title || '管理系统'} - 爱丽丝小世界管理系统`;

  // 判断路由是否需要登录
  if (to.meta.requireAuth) {
    // 直接使用localStorage检查登录状态，避免在Pinia安装前访问store
    const token = localStorage.getItem('token');
    if (token) {
      next();
    } else {
      // 未登录，跳转到登录页
      ElMessage.warning('请先登录');
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  } else {
    // 不需要登录的路由，直接放行
    next();
  }
});

export default router;
